const banners = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Banners",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Banners",
            service: "pages",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: true,
              activeLimit: 8,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Title",
                    placeholder: "Enter Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProp1: {
                  tablet: "",
                  web: "",
                  position: 1,
                  mobile: "",
                  theme: "Dark",
                  button_label: "",
                  button_link: "",
                  description: "",
                  heading: "",
                  link_label: "",
                  link_url: "",
                  title: "",
                },
              },
            },
            children: [
              {
                type: "bannerConfigTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Links",
                  // "type": "list",
                  type: "list",
                  // "variant": "filtered",
                  filter: "labels",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pr-3 pt-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    // theme: {
                    //   type: "select",
                    //   label: "Theme",
                    //   hideLabel: false,
                    //   placeholder: "Select",
                    //   required: true,
                    //   info: true,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "6",
                    //   style: "",
                    //   options: ["Dark", "Light", "Default"],
                    // },
                    preview: {
                      type: "bannersPreview",
                      label: "Banner",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    title: {
                      type: "text",
                      label: "Title",
                      placeholder: "Enter Text One",
                      required: true,
                      info: true,
                      character_count: 20,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    heading: {
                      type: "text",
                      label: "Heading",
                      placeholder: "Enter Text One",
                      required: true,
                      info: true,
                      character_count: 20,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Paragraph",
                      placeholder: "Enter Paragraph",
                      required: false,
                      info: true,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    button_label: {
                      type: "text",
                      label: "Button Label",
                      placeholder: "Enter Label",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    button_link: {
                      type: "text",
                      label: "Button Link",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    link_label: {
                      type: "text",
                      label: "Link Label",
                      placeholder: "Enter Label",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    link_url: {
                      type: "text",
                      label: "Link URL",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    // layout_2: {
                    //   preview: {
                    //     type: "bannersPreview",
                    //     label: "Banner",
                    //     required: false,
                    //     info: false,
                    //     character_count: 0,
                    //     disabled: false,
                    //     class: "",
                    //     size: "12",
                    //     style: "",
                    //   },
                    //   title: {
                    //     type: "text",
                    //     label: "Title",
                    //     placeholder: "Enter Text One",
                    //     required: true,
                    //     info: true,
                    //     character_count: 20,
                    //     disabled: false,
                    //     class: "",
                    //     size: "12",
                    //     style: "",
                    //   },
                    //   heading: {
                    //     type: "text",
                    //     label: "Heading",
                    //     placeholder: "Enter Text One",
                    //     required: true,
                    //     info: true,
                    //     character_count: 20,
                    //     disabled: false,
                    //     class: "",
                    //     size: "12",
                    //     style: "",
                    //   },
                    //   description: {
                    //     type: "ckeditor",
                    //     label: "Paragraph",
                    //     placeholder: "Enter Paragraph",
                    //     required: false,
                    //     info: true,
                    //     character_count: 2000,
                    //     disabled: false,
                    //     class: "",
                    //     size: "12",
                    //     style: "",
                    //   },
                    //   button_label: {
                    //     type: "text",
                    //     label: "Button Label",
                    //     placeholder: "Enter Label",
                    //     required: false,
                    //     info: false,
                    //     character_count: 0,
                    //     disabled: false,
                    //     class: "",
                    //     size: "6",
                    //     style: "",
                    //   },
                    //   button_link: {
                    //     type: "text",
                    //     label: "Button Link",
                    //     placeholder: "Enter Link",
                    //     required: false,
                    //     info: false,
                    //     character_count: 0,
                    //     disabled: false,
                    //     class: "",
                    //     size: "6",
                    //     style: "",
                    //   },
                    //   link_label: {
                    //     type: "text",
                    //     label: "Link Label",
                    //     placeholder: "Enter Label",
                    //     required: false,
                    //     info: false,
                    //     character_count: 0,
                    //     disabled: false,
                    //     class: "",
                    //     size: "6",
                    //     style: "",
                    //   },
                    //   link_url: {
                    //     type: "text",
                    //     label: "Link URL",
                    //     placeholder: "Enter Link",
                    //     required: false,
                    //     info: false,
                    //     character_count: 0,
                    //     disabled: false,
                    //     class: "",
                    //     size: "6",
                    //     style: "",
                    //   },
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { banners };
